module.exports = __webpack_public_path__ + "media/images/countryrect/tz-19ade52e9f255ef6eee8b8e29a821ca0.svg";